import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const KEY = "khf_token";
const AuthCtx = createContext(null);

export const setToken = (token) => {
  if (token) localStorage.setItem(KEY, token);
  else localStorage.removeItem(KEY);
  api.defaults.headers.common.Authorization = token ? `Bearer ${token}` : undefined;
};

const stored = localStorage.getItem(KEY);
if (stored) api.defaults.headers.common.Authorization = `Bearer ${stored}`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) return setReady(true);
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setToken(null))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogleSession = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", {}, {
      headers: { "X-Session-ID": sessionId },
    });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  const saveProfile = async (patch) => {
    const { data } = await api.put("/auth/me", patch);
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider
      value={{ user, ready, login, register, loginWithGoogleSession, logout, saveProfile }}
    >
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
